import { colors, fontSizes, fontWeights } from '@/theme'
import { Groups } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

interface EmptyStateProps {
  title: string
  description: string
}

export default function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 10,
        gap: 2
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: colors.brand.primaryLight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1
        }}
      >
        <Groups sx={{ fontSize: 40, color: colors.brand.primary }} />
      </Box>
      <Typography sx={{ fontSize: fontSizes.xl, fontWeight: fontWeights.bold, color: colors.text.primary }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: fontSizes.base, color: colors.text.secondary, textAlign: 'center', maxWidth: 400 }}>
        {description}
      </Typography>
    </Box>
  )
}
